export const form4HeaderCells = [
    "№п/п",
    "Наименование документа, реквизиты (номер, дата заключения)",
    "Поставщик",
    "Наименование товаров, вид работ, услуг",
    "Стоимость услуги, товаров, работ (руб.)",
    "Ссылка на копию документа*",
];
